import { OralExamMediaSource } from '@/common/api/models/oralExamMediaSource';

/** Media the student can restore from the browser (not connection or server recording). */
export const CLIENT_RESTORABLE_MEDIA_SOURCES: readonly OralExamMediaSource[] = [
  OralExamMediaSource.camera,
  OralExamMediaSource.microphone,
  OralExamMediaSource.screen,
];

export function clientRestorableOpenSources(
  openMediaSources: OralExamMediaSource[],
): OralExamMediaSource[] {
  return openMediaSources.filter((source) => (
    (CLIENT_RESTORABLE_MEDIA_SOURCES as readonly string[]).includes(source)
  ));
}

export function isRecordingIntegrityOpen(
  openMediaSources: readonly OralExamMediaSource[],
): boolean {
  return openMediaSources.includes(OralExamMediaSource.recording);
}

type MediaIntegrityProjection = {
  current?: Array<{ source?: string | null }> | null;
} | null | undefined;

export function isRecordingIntegrityOpenInRunState(runState: {
  mediaIntegrity?: MediaIntegrityProjection;
}): boolean {
  return (runState.mediaIntegrity?.current ?? []).some(
    (entry) => entry.source === OralExamMediaSource.recording,
  );
}
